import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import { useEditorTabStateSelectorForTabId } from 'src/editor/editor-tab-state-registry';
import { useCurrentTabIdOrThrow } from 'src/layouts/tabs/tab-active-context';

export function usePageWidthPx() {
  const tabId = useCurrentTabIdOrThrow();
  const pageWidthPx = useEditorTabStateSelectorForTabId(tabId, state => state.viewer.pageWidthPx);
  return { pageWidthPx };
}

export interface EditorViewPreferences {
  fullScreen: boolean;
  showNonPrintingCharacters: boolean;
  showPageBreaks: boolean;
  showRulers: boolean;
}

export const editorViewPreferencesVar = makeVar<EditorViewPreferences>({
  fullScreen: false,
  showNonPrintingCharacters: false,
  showPageBreaks: false,
  showRulers: true,
});

export function useEditorViewPreferences() {
  return useReactiveVar(editorViewPreferencesVar);
}

export function setEditorFullScreen(fullScreen: boolean): void {
  editorViewPreferencesVar({ ...editorViewPreferencesVar(), fullScreen });
}

export function setShowNonPrintingCharacters(showNonPrintingCharacters: boolean): void {
  editorViewPreferencesVar({ ...editorViewPreferencesVar(), showNonPrintingCharacters });
}

export function setShowPageBreaks(showPageBreaks: boolean): void {
  editorViewPreferencesVar({ ...editorViewPreferencesVar(), showPageBreaks });
}

export function setShowRulers(showRulers: boolean): void {
  editorViewPreferencesVar({ ...editorViewPreferencesVar(), showRulers });
}
